<template>
  <div class="categoriepartenaire-list">
    <Toolbar :handle-add="addHandler" />

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1>CategoriePartenaire List</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <CategoriePartenaireFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
            :items-per-page.sync="options.itemsPerPage"
            :loading="isLoading"
            :loading-text="$t('Loading...')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            show-select
            @update:options="onUpdateOptions"
            :footer-props="{
              'items-per-page-options': [15, 30, 50, 100],
            }"
          >
                <template slot="item.priorite" slot-scope="{ item }">
                  {{ $n(item['priorite']) }}
                </template>
                <template slot="item.partenaires" slot-scope="{ item }">
                  <ul>
                    <li v-for="_item in item['partenaires']" :key="_item.id">
                      {{ _item.id }}
                    </li>
                  </ul>
                </template>

            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
              :handle-edit="() => editHandler(props.item)"
              :handle-delete="() => deleteHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import CategoriePartenaireFilterForm from '../../components/categoriepartenaire/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';

export default {
  name: 'CategoriePartenaireList',
  servicePrefix: 'CategoriePartenaire',
  mixins: [ListMixin],
  components: {
    Toolbar,
    ActionCell,
    CategoriePartenaireFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: 'nom', value: 'nom' },
        { text: 'priorite', value: 'priorite' },
        { text: 'partenaires', value: 'partenaires' },
        {
          text: 'Actions',
          value: 'action',
          sortable: false
        }
      ],
      selected: []
    };
  },
  computed: {
    ...mapGetters('categoriePartenaire', {
      items: 'list'
    }),
    ...mapFields('categoriePartenaire', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('categoriePartenaire', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
